import { MESSAGE_TYPE, PUSH_NOTIFICATION_MODULE } from '../constants';
import { RoutesPaths } from '../Router/constant';
import api from '../services/api'
import { chatMediaAddAction, reOrganiseMessage } from './chat';
import { uploadMultipleFileAction } from './files';
import { GET_CHAT_LIST, UPDATE_CHAT_LAST_MESSAGE } from './types';

export const getAllChatList = () => (dispatch) => {
  return api.getChats().then((response) => {
    dispatch({ type: GET_CHAT_LIST, payload: response.data || [] })
    return response.data;
  });
}

export const updateChatLastMessage = (chatId, lastMessage) => ({
  type: UPDATE_CHAT_LAST_MESSAGE,
  payload: { chatId, lastMessage },
});

export const adminChatMessage = (payload) => {
  return api.adminChat(payload).then((response) => {
    return response.data;
  });
}


export const sendMessageToAdminChat = async (
  notificationBanner,
  selectedCompany,
  type,
  navigate,
  fileArray
) => {
  var sendMessage = "";
  try {
    if (type === MESSAGE_TYPE.BANNER) {
      sendMessage =
        `<strong>Notification ${notificationBanner?.callToAction?.label}:</strong> ` +
        reOrganiseMessage(notificationBanner?.message, selectedCompany);
    } else if (type === MESSAGE_TYPE.BOB_RESCHEDULE) {
      sendMessage = `<strong>Reschedule meeting:</strong> ` + reOrganiseMessage(notificationBanner);
    } else if (type === MESSAGE_TYPE.USER_DASHBOARD || type === MESSAGE_TYPE.FORMALISE_MY_HOLDING_COMPANY || type === MESSAGE_TYPE.CONTACT_US_BUTTON) {
      sendMessage = notificationBanner;
    } else {
      sendMessage = notificationBanner !== "" ? `<strong>Need help:</strong> ` + reOrganiseMessage(notificationBanner) : `<strong>Leave message:</strong>`;
    }

    if (sendMessage) {
      let payload = {}
      let filesResp = []
      if (fileArray.length > 0) {
        const fileData = new FormData();
        for (const file of fileArray) {
          fileData.append("files", file);
        }
        filesResp = await uploadMultipleFileAction(fileData);
        if (filesResp && filesResp.length > 0) {
          payload = { message: sendMessage, data: filesResp, module: PUSH_NOTIFICATION_MODULE.FILE }
        }
      } else {
        payload = { message: sendMessage, data: {}, module: "" }
      }

      const response = await adminChatMessage(payload);
      if (filesResp && filesResp.length > 0) {
        chatMediaAddAction({ channelId: response._id, media: filesResp })
      }
      navigate(RoutesPaths.MESSAGE_DETAIL + "?room=" + response._id);
    }
  } catch (error) {
  }
};